import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import PatientManualRegistration, {
	PatientManualRegistrationParams,
} from './PatientManualRegistration';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	workplaceId: string;
	onClose: () => void;
	onSuccess: (params: PatientManualRegistrationParams) => void;
	isOpened: boolean;
}
const PatientManualRegistrationModal: React.FC<Props> = ({
	isOpened,
	onClose,
	workplaceId,
	onSuccess,
}) => {
	const { isMou } = useAppContext();

	return (
		<Modal opened={isOpened} onClose={onClose} size={isMou ? Size.SM : Size.LG}>
			<Modal.Header title='base.registerThePatient' firstUpper />
			<Modal.Content contentScroll={true}>
				<PatientManualRegistration
					workplaceId={workplaceId}
					onSuccess={onSuccess}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default PatientManualRegistrationModal;
